// extracted by mini-css-extract-plugin
export default {"calender":"Calendar_calender__Enmoi","gitCalender":"Calendar_gitCalender__YSumN","stats":"Calendar_stats__ZMCur"};